<template>
  <div class="tab-buttons">
    <!-- TODO: Would be nice to only show this if dirt -->
    <Button @click="downloadConfig" variant="secondary" class="mx-1">
      Download
    </Button>
    <Button @click="$refs.fileInput.click()" variant="secondary" class="mx-1">
      Upload
    </Button>
    <Button @click="resetConfig" variant="danger" class="mx-1">
      Reset
    </Button>
    <input hidden type="file" ref="fileInput" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapGetters, mapState } from 'vuex';

import {
  downloadFile,
  serializeConfig,
  parseConfig,
  getStringFromFileChangeEvent,
} from '@/utils';
import store from '@/plugins/vuex';
import Button from '@/components/Button.vue';

export default defineComponent({
  name: 'Migrate',
  components: {
    Button,
  },
  mounted() {
    store.commit.target.setType('aison-record');

    // Hacky way to get this to work
    (this.$refs.fileInput as any).onchange = (this as any).onConfigUpload;
  },
  computed: {
    ...mapState({
      migrations: (state: any) => state.migration.migrations,
      currentMigrationIndex: (state: any) =>
        state.migration.currentMigrationIndex,
      read: (state: any) => state.read.read,
    }),
    ...mapGetters({
      source: 'source/config',
      transform: 'transform/config',
      target: 'target/config',
    }),
  },
  methods: {
    // handleNewClick() {
    //   store.dispatch.migration.new(null);
    // },
    // deleteMigration(index) {
    //   store.dispatch.migration.delete(index);
    // },
    // editMigration(index) {
    //   store.dispatch.migration.change(index);
    // },
    downloadConfig() {
      const serialized = serializeConfig({
        source: { ...(this.source || {}), read: this.read || [] },
        transform: this.transform || {},
        target: this.target || {},
      });
      downloadFile(serialized);
    },
    async onConfigUpload(e) {
      try {
        const config = await getStringFromFileChangeEvent(e).then(parseConfig);
        (this.$refs.fileInput as any).value = null;
        store.dispatch.migration.loadConfig(config);
        // Tabs do not reload data correctly, so change to summary tab
        // TODO: Fix this and remove
        store.commit.ui.setTabIndex(4);
      } catch (e) {
        alert('Failed to load config: + e');
      }
    },
    async resetConfig() {
      const result = await confirm(
        'Are you sure you want to reset current configuration?'
      );
      if (result) {
        store.dispatch.migration.reset(null);
      }
    },
  },
});
</script>
<style scoped>
.wrapper {
  margin-left: 54px;
}
</style>
